import React, { useState } from 'react';
import TaskForm from '../components/TaskForm';
import DocumentManager from '../components/DocumentManager';
import './PhaseDetail.css';

export default function PhaseDetail({ phaseId, phases, tasks, onAddTask, onUpdateTask, onDeleteTask, onBack }) {
  const phase = phases.find(p => p.id === phaseId) || { nom: 'Phase' };
  const phaseTasks = tasks.filter(t => t.phase_id === phaseId);
  const [editingTask, setEditingTask] = useState(null);

  const handleAdd = async (data) => {
    // ensure phase_id
    data.phase_id = phaseId;
    const created = await onAddTask(data);
    return created;
  };

  return (
    <div className="phase-detail">
      <div className="phase-header">
        <button className="btn" onClick={onBack}>◀ Retour</button>
        <h2>🏗️ Phase: {phase.nom}</h2>
      </div>

      <div className="grid grid-2">
        <div className="card">
          <h3>Tâches liées</h3>
          <div className="tasks-list">
            {phaseTasks.length === 0 ? (
              <div className="empty-state">Aucune tâche</div>
            ) : (
              phaseTasks.map(t => (
                <div key={t.id} className="task-item card">
                  <div>
                    <strong>{t.title}</strong>
                    <div className="muted">{t.status} • {t.priority === 1 ? '🔴' : t.priority === 2 ? '🟡' : '🟢'}</div>
                  </div>
                  <div className="task-actions">
                    <button className="btn" onClick={() => setEditingTask(t)}>✏️</button>
                    <button className="btn btn-danger" onClick={() => onDeleteTask(t.id)}>Supprimer</button>
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="card" style={{marginTop:12}}>
            <h4>Ajouter une tâche</h4>
            <TaskForm phases={phases} onSubmit={handleAdd} />
          </div>
        </div>

        <div className="card">
          <h3>Documents de la phase</h3>
          <DocumentManager phaseId={phaseId} />
        </div>
      </div>

      {editingTask && (
        <div className="edit-task-modal">
          <div className="modal-card card">
            <TaskForm phases={phases} initialData={editingTask} onSubmit={async (data) => { await onUpdateTask(editingTask.id, data); setEditingTask(null); }} onCancel={() => setEditingTask(null)} />
          </div>
        </div>
      )}
    </div>
  );
}
